import x from "../../../assets/images/X.png";
import back from "../../../assets/images/back.png";

import { useTranslation } from "react-i18next";
import { Modal } from "react-bootstrap";
import Search1 from "../../../assets/images/Search1.png";
import Previous from "../../../assets/images/Previous.png";
import brands from "../../../Json/Brand.json";

import { useLocation, useNavigate } from "react-router-dom";
import { SetSearch } from "../../../features/TopSearches/TopSearchesSlice";
import { useDispatch, useSelector } from "react-redux";
import { useState } from "react";
import {
  SetSelectdPage,
  SetSizeFilter,
  SetTopSizeFilter,
  SortProducts,
} from "../../../features/Products/ProductSlice";
import NotificationModal from "../NotificationModal";

function SeacrhMenuDesigners({
  showsectiondesigner,
  setShowSectionDesigner,
  id,
  setShowbefore,
  setShowfirst,
}) {
  const { i18n, t } = useTranslation();
  const { subtype } = useSelector((store) => store.topsearches);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [sq, setsq] = useState("");

  let parametres = new URLSearchParams(useLocation().search);
  const BrandsSection = [
    { id: "UXo5X4BP3lMoimmkMNrO" },
    { id: "nMmJX9z74ZJy98M4zse4" },
    { id: "9euIqdADV2sXs49OoXIs" },
    { id: "k2mIsRr2C2Jax6TlitBG" },
    { id: "YETcI5UACzR21ktVty4G" },
    { id: "htjMB0lyqYD7dqviSd58" },
    { id: "RiE6OzHvJgxyrv0PjE3G" },
    { id: "HOg0VXl7VqKzDg7wqn52" },
    { id: "NAHb0mOIuEtPZcqMAn94" },
    { id: "SQImHuAPQcivU49D9Obf" },
    { id: "MJSVOzPBi2vsGFu55Y7A" },
    { id: "Dzr5aum2QhF8h8rDMyrw" },
    { id: "6gCg1qU5mt67YBafPupL" },
    { id: "1qzwoL33uzzcKF9rlSrP" },
    { id: "CEjaAw6tesKQhzGBnkZe" },
    { id: "bsDmPUaLYKPCwoxLlTw0" },
    { id: "k1MUggevPUVeP4OdQA3K" },
    { id: "brvXCtEhGyu3rUs9VrcT" },
    { id: "I3Nr0lHpoWrYxLw5nzsf" },
    { id: "a6FVMVxnhctfJprZmzzK" },
    { id: "XfeeY5SoK8Ez16rAzJaH" },
    { id: "n3zJLouTWNwZnfToQxtI" },
    { id: "ng1wdK8d3lF6il3VQGae" },
    { id: "85oOOzNJVd2ArnTSJJYw" },
    { id: "gx48EN58tk80Kcwgl1xY" },
    { id: "vsUMeHPID1Rs7QdZiHD3" },
    { id: "i2u0Wg3fhUIrtsWegpsM" },
    { id: "iBJgqgPm9in6WB4B5aG1" },
  ];

  return (
    <>
      <Modal
        // className="modal fade"
        // id="SignUp"
        // tabIndex="-1"
        // role="dialog"
        // aria-labelledby="SignUp"
        show={showsectiondesigner}
        fullscreen
        className="modal fade mx-0 px-0"
      >
        {/* <div
          className="modal-dialog modal-dialog-centered modal-signup"
          role="document"
        > */}
        <Modal.Body className="p-0 m-0 ">
          <div className="modal-header justify-content-between align-items-center d-flex pb-0 px-4">
            <div
              style={{ cursor: "pointer" }}
              onClick={() => setShowSectionDesigner(false)}
            >
              <button
                type="button"
                className="close close-txt close-modal align-items-center px-0"
                data-dismiss="modal"
                aria-label="Close"
                onClick={() => setShowSectionDesigner(false)}
              >
                <img
                  alt="main"
                  src={back}
                  onClick={() => setShowSectionDesigner(false)}
                  className={` ${
                    i18n.language == "en" ? "Previous" : "PreviousAr"
                  }`}
                />

                {/* <img src={closeModal} onClick={()=>setShowSectionDesigner(false)&setShowfirst(false)} className="ms-1 mb-1 close-btn2"/> */}
              </button>
            </div>
            <button
              type="button"
              className="close close-txt close-modal align-items-center px-0"
              data-dismiss="modal"
              aria-label="Close"
              onClick={() => setShowSectionDesigner(false)}
            >
              <img
                alt="main"
                src={x}
                onClick={() => setShowSectionDesigner(false)}
                className="x-close  mb-1"
              />

              {/* <img src={closeModal} onClick={()=>setShowSectionDesigner(false)&setShowfirst(false)} className="ms-1 mb-1 close-btn2"/> */}
            </button>
          </div>

          <div className="modal-body px-4">
            <>
              <div
                className="w-100 pt-2 pb-4 px-0 align-items-center d-flex justify-content-between"
                style={{ cursor: "pointer" }}
                onClick={() =>
                  setShowSectionDesigner(false) & setShowfirst(false)
                }
              >
                <div
                  className="searchmenutitle"
                  style={{ textTransform: "uppercase" }}
                  onClick={() =>
                    navigate("/brands") &
                    setShowSectionDesigner(false) &
                    setShowfirst(false)
                  }
                >
                  {t("Designers")}
                </div>
              </div>

              {BrandsSection.map((brandsection) => (
                <>
                  {brands
                    .filter((brand) => brand.id == brandsection.id)
                    .map((brand) => (
                      <div
                        className="searchmenunew pb-4"
                        onClick={() =>
                          setShowSectionDesigner(false) & setShowfirst(false)
                        }
                      >
                        <div
                          onClick={() =>
                            navigate(
                              `/products?brand=${brand.id}&nameBrand=${brand.name}`
                            ) &
                            setShowSectionDesigner(false) &
                            setShowfirst(false)
                          }
                          className="searchmenunew "
                        >
                          {i18n.language == "en" ? brand.name : brand.nameAr}
                        </div>
                      </div>
                    ))}
                </>
              ))}
              <div
                className="w-100  pb-4 px-0 align-items-center d-flex justify-content-between"
                style={{ cursor: "pointer" }}
                onClick={() =>
                  setShowSectionDesigner(false) & setShowfirst(false)
                }
              >
                <div
                  className="searchmenunew"
                  style={{ fontFamily: "Montserrat-SemiB" }}
                  onClick={() =>
                    navigate("/brands") &
                    setShowSectionDesigner(false) &
                    setShowfirst(false)
                  }
                >
                  {t("View All Brands")}
                </div>
              </div>
            </>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default SeacrhMenuDesigners;
